import React from 'react';
import { updateProductCategoryVariables, createProductCategoryVariables } from '@api/graphql/types';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import Path from '@utils/Path';
import Form from '@components/Form/Form';

type formDataType = updateProductCategoryVariables | createProductCategoryVariables;

type Props = {
    formData: formDataType,
    onSubmit: (formData: formDataType) => Promise<any>,
} & InjectedIntlProps & RouteComponentProps;

class ProductCategoryForm extends React.Component<Props> {

    private validate = (formData: formDataType) => {
        return true;
    }

    public render() {
        const fields = [
            {name: 'name', type: 'text', props: {required: true}},
            {name: 'parent_id', type: 'productcategoryselect'},
            {name: 'url_key', type: 'text', props: {required: true}},
            {name: 'content', type: 'markdown', props: {prefix: 'categories'}},
            {name: 'date_from', type: 'date'},
            {name: 'date_to', type: 'date'},
            {name: 'keywords', type: 'text'},
            {name: 'description', type: 'text'},
            {name: 'is_enable', type: 'checkbox'},
            {name: 'show_in_menu', type: 'checkbox'},
            {name: 'is_homepage_prohibited', type: 'checkbox'},
        ];

        return (
            <Form
                fields={[{id: 'default', fields}]}
                intlPrefix={'module.productCategory'}
                onSubmit={this.props.onSubmit}
                formData={this.props.formData}
                redirectPath={Path.productCategory}
                validate={this.validate}
            />
        );
    }

}

export default compose(
    injectIntl,
    withRouter,
)(ProductCategoryForm);



// WEBPACK FOOTER //
// ./src/modules/ProductCategory/components/ProductCategoryForm.tsx